import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopupContent.StepFour',
    {
        title: 'Please check the entered information before 2FA confirmation',
        titleInLoading: 'Waiting for a response from Airwallex...',
        sectionGeneralInfo: 'General Information',
        sectionPaymentMethod: 'Payment method',
        sectionBankDetails: 'Bank details',
        sectionAddress: 'Address',
        sectionMisc: 'Miscellaneous',
    }
);
